import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { FormatAudioDuration } from "utils/numberConvert";

interface IProps {
  timeStamp: number;
  setTimestamp: (value: number) => void;
  GoToTime: (value: number) => void;
}
const LyricItemSync = ({ setTimestamp, timeStamp, GoToTime }: IProps) => {
  return (
    <>
      <LyricTimeContainer>
        <LyricTimeContainerIcon onClick={() => setTimestamp(0)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M9.5 2.5L2.5 9.50001M2.5 2.5L9.5 9.50001"
              stroke="#F5F5F5"
              stroke-width="0.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </LyricTimeContainerIcon>
        <Typography size="s">{FormatAudioDuration(timeStamp)}</Typography>
        <LyricTimeContainerIcon onClick={() => setTimestamp(timeStamp - 0.1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M10 6H2"
              stroke="#F5F5F5"
              stroke-width="0.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </LyricTimeContainerIcon>{" "}
        <LyricTimeContainerIcon onClick={() => setTimestamp(timeStamp + 0.1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M6 2V10M10 6H2"
              stroke="#F5F5F5"
              stroke-width="0.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </LyricTimeContainerIcon>
      </LyricTimeContainer>
      <PlayButton onClick={() => GoToTime(timeStamp)}>
        <PlayIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 32 32"
            fill="none"
          >
            <circle cx="15.5" cy="15.5" r="7.5" fill="#F5F5F5" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 32C24.8365 32 32 24.8365 32 16C32 7.16344 24.8365 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8365 7.16344 32 16 32ZM13.9096 22.1533L21.4619 17.6944C22.7126 16.9558 22.7126 15.0442 21.4619 14.3056L13.9096 9.8467C12.6939 9.12898 11.2 10.0632 11.2 11.5411V20.4589C11.2 21.9368 12.6939 22.871 13.9096 22.1533Z"
              fill="#4E4E4E"
            />
          </svg>
        </PlayIcon>
      </PlayButton>
    </>
  );
};

export default LyricItemSync;

const LyricTimeContainer = styled.div`
  width: 14.5rem;
  background-color: ${Colors.grey600};
  border-radius: 2.4rem;
  display: flex;
  padding: 0.8rem 1.2rem;
  justify-content: space-evenly;
  align-items: center;
`;

const LyricTimeContainerIcon = styled.div`
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
`;

const PlayButton = styled.div`
  cursor: pointer;
  width: 3.2rem;
  height: 3.2rem;
  background-color: ${Colors.grey600};
  border-radius: 50%;
`;

const PlayIcon = styled.div`
  width: 3.2rem;
  height: 3.2rem;
`;
